import React from 'react';
import { Help, SystemText } from '@salesperformanceint/e4shared';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import BlobImage from 'components/blobImage';
import Bullet from 'components/prism/bullet';
import Rating from 'components/prism/rating';
import { translateCompetency } from 'helpers/translations';

export const Behaviour = ({ item, padBottom }) => {
    const { user } = useSelector(state => state.user);

    const text = {
        flagged: SystemText('Controls/Behavior/Flagged'),
        courses: x =>
            x === 1 ? SystemText('Controls/Behavior/Courses', x) : SystemText('Controls/Behavior/CoursesPlural', x),
        metrics: x =>
            x === 1 ? SystemText('Controls/Behavior/Metrics', x) : SystemText('Controls/Behavior/MetricsPlural', x),
    };

    item = translateCompetency(user.language_Code, item);

    return (
        <Link
            key={`recommended-${item.id}`}
            to={`/behavior/${item.id}`}
            className={`prism-content-box anchor-top ${padBottom ? 'mb10' : ''}`}
        >
            <div className="prism-banner-float flex flex-center">
                <Bullet type="behavior" />
                <div className="flex-grow text-right">
                    <div className="btn-fake" aria-label={item.flagged ? text.flagged : ''}>
                        {item.flagged ? (
                            <Help id={`flag-help-${item.id}`} target={<i className="fa fa-flag fa-solid" />}>
                                {text.flagged}
                            </Help>
                        ) : (
                            <i className="fa fa-flag" />
                        )}
                    </div>
                </div>
            </div>
            <div className="prism-banner">
                {item.image ? (
                    <BlobImage src={item.image} folder="competency_Image" noholder />
                ) : (
                    <img src="/dist/img/defaults/behavior-default.jpg" />
                )}
            </div>
            <div className="prism-content flex flex-column">
                <h3>{item.name}</h3>
                <div className="flex-grow">{item.description && <p className="truncate-4">{item.description}</p>}</div>
                <div className="flex flex-center">
                    <div className="flex-grow">
                        <b>{text.courses(item.courseCount)}</b> &bull; <b>{text.metrics(item.metricCount)}</b>
                    </div>
                    <Rating level={item.level} />
                </div>
            </div>
        </Link>
    );
};

export default Behaviour;
